/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionActivePolicyQuery from '../graphql/queries/GetSouscriptionActivePolicyQuery.js';

const useGetSouscriptionActivePolicyQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionActivePolicyQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionActivePolicy: R.omit(['__typename'], data?.getSouscriptionActivePolicy_souscription_active_policy || {})
  };
};

export default useGetSouscriptionActivePolicyQuery;
